export const siteTitle = 'Filmsomniac.com'

const sectionTitles = {
  credits: 'Credits',
  seasons: 'Seasons',
  lists: 'Lists',
  comments: 'Discussion',
  discussion: 'Discussion',
  you: 'Your watch data',
  tv: 'TV appearances',
}

export function buildDocumentTitle(parts, section = '') {
  const pageTitle = parts
    .map((part) => String(part || '').trim())
    .filter(Boolean)
    .join(' - ')

  const sectionTitle = sectionTitles[String(section).toLowerCase()]
  const title = pageTitle && sectionTitle ? `${pageTitle} | ${sectionTitle}` : pageTitle

  return title ? `${title} - ${siteTitle}` : siteTitle
}

export function setDocumentTitle(title) {
  if (typeof document === 'undefined') {
    return
  }

  document.title = title || siteTitle
}
